import React from 'react'

import { useTranslation } from 'react-i18next'
import { ReactComponent as HotmartIconNotAllowed } from './assets/images/icon.svg'

import './assets/styles/index.scss'

function NotAllowed() {
  const { t } = useTranslation()

  return (
    <div className="not-allowed" data-testid="not-allowed-component">
      <header className="not-allowed__header"></header>
      <main
        className="not-allowed__container _bg-white _p-6 _p-md-7
      _d-flex _flex-column _align-items-center _flex-md-row"
      >
        <div>
          <h5 className="not-allowed__title _text-3 _text-md-4 _line-height _font-weight-light">
            {t('collaborators_area.not_allowed_page.title')}
          </h5>
          <p className="not-allowed__text _text-2 _text-md-3 _text-gray-500 _line-height _font-weight-light">
            {t('collaborators_area.not_allowed_page.description')}
          </p>
        </div>
        <HotmartIconNotAllowed className="not-allowed__icon" />
      </main>
    </div>
  )
}

export default NotAllowed
